import { http } from '../services';

class LoginService {
    async loginForm() {
        return http.get('/login/form');
    }

    loginPeloEmail(login) {
        return http.post('/loginemail', login);
    }
    loginPeloLogos(login) {
        return http.post('/loginlogos', login);
    }

    logout() {
        return http.post('/logout');
    }

    getNome() {
        return http.get('/nome');
    }
}

const loginService = new LoginService();
export default loginService;
